module.exports = __webpack_public_path__ + "zl9-9eb9b7ba.png";